<div class="candidacy-status" [ngClass]="statusClassName">
  {{ statusTranslationKey | translate }}
</div>
